
export default (data) => {

  console.log('update-list-common')

  const tbody = document.querySelector('tbody[data-target="tbody-list"]')
  tbody.innerHTML = data['tbody']

  const totalItems = document.querySelector('span[data-target="total-value-count"]')
  if( totalItems ) {
    totalItems.innerHTML = data['pagination']['totalItems']
  }

  const totalPages = document.querySelectorAll('.pagination__all-pages')
  totalPages.forEach((element) => {
    element.innerHTML = '/' + data['pagination']['totalPages']
  })

  const pageBack = document.querySelectorAll('.pagination__pages-arrow_back')
  pageBack.forEach((element) => {
    element.setAttribute('data-page', data['pagination']['prev'])
    if( data['pagination']['prevHide'] ) {
      element.classList.add('pagination__pages-arrow_hidden');
    }
    else {
      element.classList.remove('pagination__pages-arrow_hidden');
    }
  })

  const pageForward = document.querySelectorAll('.pagination__pages-arrow_forward')
  pageForward.forEach((element) => {
    element.setAttribute('data-page', data['pagination']['next'])
    if( data['pagination']['nextHide'] ) {
      element.classList.add('pagination__pages-arrow_hidden');
    }
    else {
      element.classList.remove('pagination__pages-arrow_hidden');
    }
  })

}

